import { useEffect, useRef } from "react"
import flatpickr from "flatpickr"
import { CalendarIcon } from "@mui/x-date-pickers"

const RouteDatePicker = ({ value, onChange }) => {
    const inputRef = useRef(null)
    const fpRef = useRef(null)

    useEffect(() => {
        if (!inputRef.current) return

        fpRef.current = flatpickr(inputRef.current, {
            dateFormat: "F j, Y",
            defaultDate: value || new Date(),
            allowInput: false,
            clickOpens: false, // input click disable
            onChange: (selectedDates) => {
                onChange?.(selectedDates[0])
            },
        })

        return () => {
            fpRef.current?.destroy()
        }
    }, [])

    const handleOpen = () => {
        fpRef.current?.open()
    }

    return (
        <div className="e-route-date-picker" onClick={handleOpen}>
            <CalendarIcon fontSize="small" />
            <input ref={inputRef} className="e-route-date-input" readOnly />
        </div>
    )
}

export default RouteDatePicker
